// extracted by mini-css-extract-plugin
module.exports = {"userContainer":"user-block_userContainer__wIpBM","info":"user-block_info__2Zgf9","menu":"user-block_menu__83Sjk"};